export const tagsStateEnum = [
    {
        stateId: 1,
        stateName: "启用"
    },
    {
        stateId: 0,
        stateName: "禁用"
    },
    {
        stateId: 2,
        stateName: "待审核"
    },
    {
        stateId: 3,
        stateName: "审核未通过"
    },
    {
        stateId: 4,
        stateName: "重审中"
    }
]
